import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/go-vue/client/layouts/default.vue").then(m => m.default || m))
}